import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Container } from "reactstrap";
import { Descriptions } from "antd";

const SingleComponent = () => {
  let { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (data === null) {
      axios
        .get(`https://backendexample.sanbersy.com/api/data-game/${id}`)
        .then((res) => {
          setData(res.data);
        });
    }
  }, [data, setData, id]);

  return (
    <Container>
      <Descriptions title="Games Info">
        <Descriptions.Item label="Name">
          {data !== null && data.name}
        </Descriptions.Item>
        <Descriptions.Item label="Genre">
          {data !== null && data.genre}
        </Descriptions.Item>
        <Descriptions.Item label="Mode">
          {data !== null && data.singlePlayer}
        </Descriptions.Item>
        <Descriptions.Item label="Platform">
          {data !== null && data.platform}
        </Descriptions.Item>
        <Descriptions.Item label="Release">
          {data !== null && data.release}
        </Descriptions.Item>
      </Descriptions>
    </Container>
  );
};

export default SingleComponent;
